import React from "react";
import {Link} from "react-router-dom";
import {FiTrash2} from "react-icons/fi";

const FILTER_COLORS = {
    primary:  {background: "#2563eb", color: "#fff",    border: "none",                 fontWeight: 700, padding: "6px 16px"},
    outline:  {background: "#fff",    color: "#475569", border: "1px solid #cbd5e1",    fontWeight: 600, padding: "6px 12px"},
    danger:   {background: "#ef4444", color: "#fff",    border: "none",                 fontWeight: 700, padding: "6px 12px"},
};

export const FilterButton = ({
    text,
    onClick,
    loading,
    type = "button",
    color = "primary",
    icon,
    disabled = false,
    fullWidth = false,
}) => {
    const {fontWeight, padding, ...colorStyle} = FILTER_COLORS[color] ?? FILTER_COLORS.primary;
    return (
        <button
            onClick={onClick}
            disabled={loading || disabled}
            type={type}
            style={{
                display: fullWidth ? "flex" : "inline-flex",
                width: fullWidth ? "100%" : undefined,
                justifyContent: fullWidth ? "center" : undefined,
                alignItems: "center",
                gap: "4px",
                padding,
                fontSize: "var(--enigoo-fs-xs)",
                fontWeight,
                borderRadius: "999px",
                cursor: loading || disabled ? "not-allowed" : "pointer",
                opacity: loading || disabled ? 0.55 : 1,
                transition: "opacity 0.15s",
                ...colorStyle,
            }}
        >
            {icon}
            <span>{loading ? "Načítám..." : text}</span>
        </button>
    );
};

const COLORS = {
    primary:     {background: "#2563eb", color: "#fff",     border: "none"},
    outline:     {background: "#fff",    color: "#2563eb",  border: "1px solid #2563eb"},
    danger:      {background: "#ef4444", color: "#fff",     border: "none"},
    success:     {background: "#22c55e", color: "#fff",     border: "none"},
    outlineGray: {background: "#fff",    color: "#475569",  border: "1px solid #cbd5e1"},
};

export const TurnstileButton = ({
    text,
    onClick,
    loading,
    type = "button",
    color = "primary",
    link = null,
    icon,
    disabled = false,
}) => {
    const colorStyle = COLORS[color] ?? COLORS.primary;

    const button = (
        <button
            onClick={onClick}
            disabled={loading || disabled}
            type={type}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "6px 12px",
                fontSize: "var(--enigoo-fs-xs)",
                fontWeight: 700,
                borderRadius: "7px",
                letterSpacing: "0.04em",
                cursor: loading || disabled ? "not-allowed" : "pointer",
                opacity: loading || disabled ? 0.55 : 1,
                transition: "opacity 0.15s",
                ...colorStyle,
            }}
        >
            {icon}
            <span>{loading ? "PRACUJI..." : text}</span>
        </button>
    );

    if (link) return <Link to={link} style={{textDecoration: "none"}}>{button}</Link>;
    return button;
};

export const FieldArrayAddButton = ({text, onClick}) => (
    <button type="button" onClick={onClick} style={{
        display: "inline-flex", alignItems: "center", gap: "4px",
        padding: "5px 10px", background: "#eff6ff", color: "#2563eb",
        border: "1px solid #bfdbfe", borderRadius: "6px",
        fontSize: "var(--enigoo-fs-xs)", fontWeight: 600, cursor: "pointer", marginBottom: "8px",
    }}>
        {text}
    </button>
);

export const FieldArrayDeleteButton = ({onClick}) => (
    <button type="button" onClick={onClick} style={{
        display: "inline-flex", alignItems: "center", gap: "4px",
        padding: "4px 8px", background: "#fef2f2", color: "#dc2626",
        border: "1px solid #fecaca", borderRadius: "6px",
        fontSize: "var(--enigoo-fs-xs)", fontWeight: 600, cursor: "pointer",
    }}>
        <FiTrash2 size={11}/> Odebrat
    </button>
);
